import type { Maybe, ProductImage, ProductVideo } from '@pylot-data/pylotschema'

export const getGalleryMediaKey = (
    image: Maybe<ProductVideo | ProductImage>,
    index: number
): string => {
    const type = image?.__typename ?? 'media'
    const position = image?.position
    const url = image?.url

    if (position != null && url) {
        return `${type}-${position}-${url}`
    }

    if (url) {
        return `${type}-${index}-${url}`
    }

    return `${type}-${index}`
}

/** Índice del primer slide que es imagen (no video ni AR). Para LCP/priority. */
export const getFirstGalleryImageIndex = (
    entries: Maybe<ProductVideo | ProductImage>[]
): number =>
    (entries ?? []).findIndex(
        (entry) => entry?.__typename !== 'ProductVideo' && !entry?.arLink
    )
